import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './ProDetail.css';

function ProDetail() {
  const { slug } = useParams();
  const [pro, setPro] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetch(`/api/professionnels/${slug}`)
      .then(res => res.json())
      .then(data => {
        setPro(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur:', err);
        setLoading(false);
      });
  }, [slug]);

  const trackClick = (type) => {
    if (pro) {
      fetch('/api/stats/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ professionnel_id: pro.id, type_action: type })
      });
    }
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!pro) {
    return (
      <div className="error-page">
        <h1>404</h1>
        <p>Professionnel non trouve</p>
        <Link to="/categories" className="btn btn-primary">Voir les categories</Link>
      </div>
    );
  }

  return (
    <div className="pro-detail">
      <Helmet>
        <title>{pro.nom} | Annuaire des Pros - E-Shop Pro</title>
        <meta name="description" content={pro.description_courte || pro.description?.substring(0, 160)} />
        <link rel="canonical" href={`https://annuaire.e-shop-pro.fr/pro/${slug}`} />
      </Helmet>
      
      <div className="pro-hero">
        <div className="container">
          <Link to={`/categorie/${pro.categorie_slug}`} className="pro-back">
            ← {pro.categorie_nom}
          </Link>
          <h1>{pro.nom}</h1>
          <p className="pro-hero-location">📍 {pro.ville}</p>
          {pro.site_cree_par_nous && (
            <div className="created-badge">✓ Site cree par E-Shop Pro</div>
          )}
        </div>
      </div>
      
      <div className="container">
        <div className="pro-grid">
          <div className="pro-main">
            <section className="pro-section">
              <h2>A propos</h2>
              <p>{pro.description}</p>
            </section>
            
            {pro.temoignage && (
              <section className="pro-section testimonial">
                <h2>Ce qu'ils disent de nous</h2>
                <blockquote>
                  <p>{pro.temoignage}</p>
                  <footer>— {pro.nom}</footer>
                </blockquote>
              </section>
            )}
            
            {pro.resultats_obtenus && (
              <section className="pro-section">
                <h2>Resultats obtenus</h2>
                <p>{pro.resultats_obtenus}</p>
              </section>
            )}
            
            {pro.technologies_utilisees && (
              <section className="pro-section">
                <h2>Technologies utilisees</h2>
                <div className="tech-tags">
                  {pro.technologies_utilisees.split(',').map((tech, i) => (
                    <span key={i} className="tech-tag">{tech.trim()}</span>
                  ))}
                </div>
              </section>
            )}
          </div>
          
          <aside className="pro-sidebar">
            <div className="sidebar-card">
              <h3>Contact</h3>
              {pro.site_web && (
                <a href={pro.site_web} target="_blank" rel="noopener noreferrer" 
                   className="sidebar-link" onClick={() => trackClick('clic_site')}>
                  🌐 Visiter le site
                </a>
              )}
              {pro.telephone && (
                <a href={`tel:${pro.telephone}`} className="sidebar-link"
                   onClick={() => trackClick('clic_telephone')}>
                  📞 {pro.telephone}
                </a>
              )}
              {pro.email && (
                <a href={`mailto:${pro.email}`} className="sidebar-link"
                   onClick={() => trackClick('clic_email')}>
                  ✉️ Envoyer un email
                </a>
              )}
              {pro.adresse && (
                <p className="sidebar-address">📍 {pro.adresse}</p>
              )}
            </div>
            
            <div className="sidebar-card cta-card">
              <h3>Vous aussi ?</h3>
              <p>Vous voulez un site comme celui-ci pour votre activite ?</p>
              <Link to="/contact" className="btn btn-primary" style={{width: '100%'}}>
                Demander un devis
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

export default ProDetail;
